import { InjectionToken } from '@angular/core';

export const APP_CONFIG = new InjectionToken<AppConfig>('app.config');

export interface AppConfig {
  production: boolean;
  environment: string;
  ldClientKey: string;
  accountsApiUrl: string;
  v3ApiUrl: string;
  v4ApiUrl: string;
  v4FrontendUrl: string | null;
  auth0ClientId: string;
  auth0Subdomain: string;
  auth0Domain: string;
  auth0Audience: string;
  auth0Scope: string;
  auth0Users: Array<string>;
  tenantId: string;
}
